// // 模块的GIS逻辑
// import Util from './Util';
import Service from '../../../service/ServiceFactory';

const componentBase = (G as any).base.ComponentBase;
const component = componentBase.extend({
    // 属性
    options: {
        highLightId: 'districtSearch_comp', // 高亮id
        tempHighLightId: 'temp_highlight',
        popupId: 'popup_districtSearch_comp', // 弹窗唯一标识
        msgId: 'msg_popup',
        popupEventName: 'popup', // 详情框事件名
        featureType: 'districtSearch_comp', // 图层标识
        bufferLayer: 'around_buffer_comp', // 范围图层标识,
        // panoMapEnterEventName: 'PanoMapClick', // 全景地图点击监听事件名称
        mapConfig: { center: [108.940764, 34.278987], zoom: 5 }, // 中国视野
    },
    // createWPSSService() {
    //     return Service.createService('RestWPSSService', {}, this.options.serviceConfig.egis);
    // },
    createWRGSService() {
        return Service.createService('RestWRGSService', {}, this.options.serviceConfig.egis);
    },
    // 初始化
    initialize(options: any) {
        componentBase.prototype.initialize.call(this, options);
        this.map.on('drag', () => {
            this.regeocode().then((result: any) => {
                const region = this.getRegion(result);
                this.fire('drag', region);
            });

        });
        this.map.on('extentchanged', () => {
            // console.log(this.map.getExtent());
        });
        // this.wpssService = this.wpssService || this.createWPSSService();
        this.wrgsService = this.wrgsService || this.createWRGSService();

    },
    //  销毁
    destroy() {
        componentBase.prototype.destroy.call(this);
    },

    currentLevel() {
        return Math.round(this.map.getZoomLevel());
    },

    getRegion( result: any) {
        const level = this.currentLevel();
        let region = '1';
        let cityArr = [];
        if ( level >= 11 ) {
            const address = result.address_component.city;
            const addressArr = address.split('省');
            if (addressArr.length > 1) {
                cityArr = addressArr[1].split('市');
            } else {
                cityArr = addressArr[0].split('市');
            }
            region = cityArr[0];
        } else if ( level >= 9 && level < 11 ) {
            region = result.address_component.province;
        }
        return region;
    },

    locate(location: any) {
        if (!!location) {
            const center = new egis.sfs.Point({
                x: !!location.x ? location.x : Number(!!location.lng ? location.lng : location.split(',')[0]),
                y: !!location.y ? location.y : Number(!!location.lat ? location.lat : location.split(',')[1]),
                spatialReference: egis.sfs.EnumSpatialReference.EPSG4326,
            });
            this.map.pan(center);
        }
    },

    regeocode() {
        const mapCenter = this.map.getCenter();
        const wrgsInput = new egis.ews.WRGSInput({
            location: mapCenter.x + ',' + mapCenter.y,
        });
        return new Promise((resolve, reject) => {
            this.wrgsService.regeocode(wrgsInput).then((response: any) => {
                resolve(response);
            });
        });
    },

    load(data: any, location?: string, radius?: number) {
        componentBase.prototype.load.call(this);
        if (!!data) {
            this._load(data);
        }
        // if (!!location && !!radius) {
        //     this._addBuffer(location, radius);
        // }

    },

    unload() {
        this.options.simpleRenderMgr.remove(this.options.featureType);
        // this.closePopup();
        // this.removehighlight();
        if (this.polygonFeatureLayer) { this.polygonFeatureLayer.clear(); }
        componentBase.prototype.unload.call(this);
    },

    addListeners() {
        // 添加事件监听，load调用时父类触发
    },

    removeListeners() {
        // 移除事件监听，unload调用时父类触发
        // this.map.off('click', () => {
        //     console.log('map click');
        // });
    },

    fitChina() {
        if (this.polygonFeatureLayer) {
            this.polygonFeatureLayer.clear();
        }
        const center = new g2.sfs.Point({
            x: this.options.mapConfig.center[0],
            y: this.options.mapConfig.center[1],
            spatialReference: this.map.spatialReference,
        });
        this.map.setCenter(center);
        this.map.zoomTo(this.options.mapConfig.zoom);
    },

    panToCity(data: any) {
        const bounds = data.bound.split(',');
        const envelope = new g2.sfs.Envelope({
            spatialReference: this.map.spatialReference, // 坐标系
            minx: bounds[0],  // x最小值
            miny: bounds[1],  // y最小值
            maxx: bounds[2],  // x最大值
            maxy: bounds[3],  // y最大值
        });
        this.map.pan(envelope);
    },
});

export default component;
